<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { kydkpz_queryCompanyList } from '../../../../api/kydkpz.js';
import config from '../../../../../configHttp.js';
import { MainFunction } from '@/components/util/Function/MainFunction';
import { xxtjb_query } from "../../../../api/xxtjb";
import xxtbjmx from "./xxtbjmx/index.vue";
import xxtbjmxfp from "./xxtbjmxfp/index.vue";
import xxtbjmxpz from "./xxtbjmxpz/index.vue";
export default {
	data: function () {
		return {
			headData: getdata().headData,
			pagination: getdata().pagination,
			tableData: [],
			// 初始化公司
			companyCode: '',
			// 导出传参类型
			outputData: getdata().outputData,
			tablekey: 0,
			showMx: false,
			showMxpz: false,
			showMxfp: false,
			suosq: MainFunction.$getdefultMonth(),
			mxInitData: {
				companyNo: "",
				options: []
			},
			//公司下拉
			options: [{
				value: '',
				label: '全部'
			}]
		}
	},
	methods: {
		sizechange(e) {
			this.pagination.pageSize = e;
			this.fetchResultShow()
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.fetchResultShow();
		},
		currStationChange(v) {
			this.companyCode = v;
			this.fetchResultShow();
		},
		closesgdj() {
			this.fetchResultShow();
			this.showMx = false;
			this.showMxfp = false;
			this.showMxpz = false;
		},
		// 查询结果(分页)
		fetchResultShow() {
			let params = {}
			params.suosq = this.suosq;
			params.companyCode = this.companyCode;
			xxtjb_query(params).then(res => {
				if (res.data.code != 1) {
					this.$message.error(res.data.msg);
				} else {
					this.tableData = res.data.data;
				}
			});
			// this.tableData = getdata().initdata;
		},
    //刷新
    forRefresh(){
      this.pagination.pageNum = 1
      this.pagination.paginationkey++
      this.fetchResultShow()
    },
		//查询当前公司
		chaxungongshihesju() {
			kydkpz_queryCompanyList().then(res => {
				if (res.data.msg == '操作成功') {
					let _data = res.data.data.map(v => {
						return {
							value: v.companyCode,
							label: v.nsrmc
						};
					});
					this.options.push(..._data);
					this.fetchResultShow();
				} else {
					this.$message.error(res.data.msg);
				}
			});
		},
		toDetail(val, type) {
			this.mxInitData.companyCode = this.companyCode;
			this.mxInitData.options = this.options;
			this.mxInitData.businessTypeName = val.businessTypeName;
			this.mxInitData.businessType = val.businessType;
			this.mxInitData.type = type;
			this.mxInitData.suosq = this.suosq;
			this.mxInitData.resRange = val.resRange;
			if (val.resRange == '3') {
				this.showMx = true;
			} else if (val.resRange == '1' || (val.resRange == '4' && type == '1')) {
				this.showMxfp = true;
			} else {
				this.showMxpz = true;
			}
		},
		// 导出结果
		outPutXXTJBResult() {
			let data = { data: this.tableData };
			let params = {
				downUrl: config.baseURL + 'dataDisposeCenter/adjust/export',
				typeObj: {
					toForm: false,
					fileName: '销项调节表一览' + this.$timestampToStr(new Date(), 'yyyyMMdd'),
					fileType: 'xlsx',
					failUrl: this.$winURl
				},
				params: data
			};
			this.$downloadcommon(params);
		}
	},
	components: {
		xxtbjmx,
		xxtbjmxfp,
		xxtbjmxpz
	},
	created() {
		this.chaxungongshihesju();
	},
	mounted() { },
	computed: {
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
